{
  "instances": {
    "heapdump": {
      "label": "Дамп кучи",
      "download": "Загрузить дамп кучи",
      "warn_dump_expensive": "Снятие дампа кучи может быть затратен с точки зрения ЦПУ и дискового пространства.",
      "warn_sensitive_data": "Дамп кучи может содержать конфиденциальную информацию. Пожалуйста, будьте осторожны."
    }
  }
}
